import { Component } from '@angular/core';

@Component({
    selector: 'app-left-nav-img',
    templateUrl: './left-nav-img.component.html',
    styleUrls: ['./left-nav-img.component.scss'],
    standalone: false
})
export class LeftNavImgComponent {}
